import { Box, Icon, SimpleGrid, useColorModeValue, Input, InputGroup, InputLeftElement, Spinner, Flex, Text, Button, HStack, Collapse } from "@chakra-ui/react";
import Profils from "views/admin/default/components/Profils";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdBarChart } from "react-icons/md";
import { GrMoney } from "react-icons/gr";
import { MdClose , MdOutlineSell, MdSearch, MdExpandMore, MdExpandLess, MdAddCircleOutline, MdOutlineCalendarToday  } from "react-icons/md";
import ProperimeAndExtraSalesChart from "views/admin/default/components/ProperimeAndExtraSalesChart";
import Patients from "views/admin/default/components/Patients";
import Utilisations from "views/admin/default/components/Utilisations";
import PlaintesConsultees from "views/admin/default/components/PlaintesConsultees";
import InteractionsStat from "views/admin/default/components/InteractionsStat";
import { API_URL, CURRENCY } from "../../../constants";
import {getAuthToken} from "../../../helpers/helpers"

export default function UserReports() {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const cardBg = useColorModeValue("white", "navy.800");
  const cardBgExpanded = useColorModeValue("brand.50", "navy.700");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [totalProp, setTotalProp] = useState(0);
  const [products, setProducts] = useState(0);
  const [equivalent, setEquivalent] = useState(0);
  const [totalVentes, setTotalVentes] = useState(0);
  const [venteProperime, setVenteProperime] = useState(0);
  const [totalPropVend, setTotalPropVend] = useState(0);
  const [venteExtraStock, setVenteExtraStock] = useState(0);
  const [venteExtraStockValue, setVenteExtraStockValue] = useState(0);
  const [venteExtraSold, setVenteExtraSold] = useState(0);
  const [venteExtraSoldValue, setVenteExtraSoldValue] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isProPerimeExpanded, setIsProPerimeExpanded] = useState(false);
  const [isVenteExtraExpanded, setIsVenteExtraExpanded] = useState(false);
  const [totalSalesValue, setTotalSalesValue] = useState(0);
  const [totalInventoryValue, setTotalInventoryValue] = useState(0);
  const [dashboardCurrency, setDashboardCurrency] = useState(CURRENCY.code);

  const handleApplyFilter = () => {
    if (startDate && endDate) {
      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
    }
  };

  const handleClearFilter = () => {
    setStartDate("");
    setEndDate("");
    setAppliedStartDate("");
    setAppliedEndDate("");
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const token = getAuthToken();

      const response2 = axios
        .get(`${API_URL}/api/properemption_medicament`, {
          headers: { 
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
           },
        })
        .catch((error) => {
          console.log("Error fetching properemption_medicament:", error);
          return { data: [] };
        });

      const response3 = axios
        .get(`${API_URL}/api/cart`, {
          headers: { 
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
           },
        })
        .catch((error) => {
          console.log("Error fetching cart:", error);
          return { status: 404, data: [] };
        });

      const response4 = axios
        .get(`${API_URL}/api/inventory/vente_extra`, {
          headers: { 
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
           },
        })
        .catch((error) => {
          console.log("Error fetching vente_extra:", error);
          return { data: [] };
        });

      const response5 = axios
        .get(`${API_URL}/api/dashboard/summary`, {
          headers: {
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
          },
          params: {
            ...(appliedStartDate && { startDate: appliedStartDate }),
            ...(appliedEndDate && { endDate: appliedEndDate }),
          },
        })
        .catch((error) => {
          console.log("Error fetching dashboard summary:", error);
          return { data: { totalSalesValue: 0, totalInventoryValue: 0, currency: CURRENCY.code } };
        });

      try {
        const [res2, res3, res4, res5] = await Promise.all([response2, response3, response4, response5]);

        let filtered = res2.data.filter(
          (elem) => !elem.masked && elem.qte_stock > 0
        );

        let price = 0;
        let total = 0;
        filtered.forEach((item) => {
          price += item.prix * item.qte_stock;
          total += item.qte_stock;
        });
        setProducts(total);
        setEquivalent(price.toFixed(3));

        let counter = [];
        filtered.forEach((item) => {
          if (!counter.includes(item.specialite)) {
            counter.push(item.specialite);
          }
        });
        setTotalProp(counter.length);

        function isNearExpiry(saleDate, expirationDate, nearExpiryMonths) {
          const d1 = saleDate instanceof Date ? saleDate : new Date(saleDate);
          const d2 = expirationDate instanceof Date ? expirationDate : new Date(expirationDate);
          const months = (nearExpiryMonths != null) ? nearExpiryMonths : 6;

          const monthDiff =
            (d2.getFullYear() - d1.getFullYear()) * 12 +
            (d2.getMonth() - d1.getMonth());

          return monthDiff >= 0 && monthDiff <= months;
        }

        if (res3.status !== 404) {
          let ventes = 0;
          let venteProp = 0;
          let propVend = 0;
          let extraSold = 0;
          let extraSoldValue = 0;


          // Comparer la date sélectionnée avec la date "created_at"
          const filteredCartItems = res3.data.filter((item) => {
            const createdAt = new Date(item.created_at);
            if (appliedStartDate && appliedEndDate) {
              const start = new Date(appliedStartDate);
              const end = new Date(appliedEndDate);
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              return createdAt >= start && createdAt <= end;
            }
            return true;
          });

          filteredCartItems.forEach((item) => {
            ventes += item.items.length;
            item.items.forEach((elem) => {
              if (elem) {
                const expirationDate = new Date(elem.date_peremption || 0);
                const quantity = elem.quantity || 0;
                const price = elem.medicamentDetails?.prix || 0;

                if (isNearExpiry(item.created_at, expirationDate, elem.medicamentDetails?.nearExpiryMonths ?? elem.nearExpiryMonths ?? 6)) {
                  venteProp += quantity;
                  propVend += quantity * price;
                }

                // Count vente extra sold items
                if (elem.extra === true) {
                  extraSold += quantity;
                  extraSoldValue += quantity * price;
                }
              }
            });
          });

          setTotalVentes(ventes);
          setVenteProperime(venteProp);
          setTotalPropVend(propVend);
          setVenteExtraSold(extraSold);
          setVenteExtraSoldValue(extraSoldValue);
        }

        // Process vente extra in stock
        if (res4.data && res4.data.length > 0) {
          let extraStockVal = 0;
          const specialiteSet = new Set();
          res4.data.forEach((item) => {
            const qty = item.qte_stock || 0;
            const price = parseFloat(item.prix) || 0;
            const remise = parseFloat(item.remise) || 0;
            const effectivePrice = remise > 0 ? price * (1 - remise / 100) : price;
            extraStockVal += qty * effectivePrice;
            // only count a specialite once if it has stock and is not masked
            if (qty > 0 && item.specialite && !item.masked) {
              specialiteSet.add(item.specialite);
            }
          });
          // set the count of distinct specialite for vente extra in stock
          setVenteExtraStock(specialiteSet.size);
          setVenteExtraStockValue(extraStockVal);
        } else {
          setVenteExtraStock(0);
          setVenteExtraStockValue(0);
        }

        // Process dashboard financial summary
        if (res5.data) {
          setTotalSalesValue(res5.data.totalSalesValue || 0);
          setTotalInventoryValue(res5.data.totalInventoryValue || 0);
          setDashboardCurrency(res5.data.currency || CURRENCY.code);
        }
      } catch (error) {
        console.log("Error during fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [appliedStartDate, appliedEndDate]); 

  if (isLoading) {
    return (
      <Flex
        pt={{ base: "130px", md: "80px", xl: "80px" }}
        w="100%"
        h="80vh"
        justify="center"
        align="center"
        direction="column"
        gap="20px"
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="brand.500"
          size="xl"
        />
        <Text color="secondaryGray.600" fontSize="lg" fontWeight="500">
          Chargement des données...
        </Text>
      </Flex>
    );
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
       <Box display="flex" justifyContent="flex-end" mb="20px" w="100%">
        <HStack spacing={2} flexWrap="wrap" justify="flex-end" align="center">
          <Text fontSize="sm" fontWeight="500" color="secondaryGray.600">du</Text>
          <InputGroup size="sm" w={{ base: "130px", md: "150px" }}>
            <InputLeftElement
              pointerEvents="none"
              children={<Icon as={MdOutlineCalendarToday} color="gray.400" w="16px" h="16px" />}
            />
            <Input
              type="date"
              placeholder="Date début"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              bg="white"
              borderRadius="16px"
              boxShadow="sm"
              max={endDate || new Date().toISOString().split("T")[0]}
              border="2px solid"
              _hover={{
                borderColor: "blue.500",
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px blue.500",
              }}
            />
          </InputGroup>
          <Text fontSize="sm" fontWeight="500" color="secondaryGray.600">à</Text>
          <InputGroup size="sm" w={{ base: "130px", md: "150px" }}>
            <InputLeftElement
              pointerEvents="none"
              children={<Icon as={MdOutlineCalendarToday} color="gray.400" w="16px" h="16px" />}
            />
            <Input
              type="date"
              placeholder="Date fin"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              bg="white"
              borderRadius="16px"
              boxShadow="sm"
              min={startDate}
              max={new Date().toISOString().split("T")[0]}
              border="2px solid"
              _hover={{
                borderColor: "blue.500",
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px blue.500",
              }}
            />
          </InputGroup>
          <Button
            colorScheme="blue"
            size="sm"
            borderRadius="16px"
            onClick={handleApplyFilter}
            isDisabled={!startDate || !endDate}
            leftIcon={<Icon as={MdSearch} />}
          >
            Filtrer
          </Button>
          {(appliedStartDate || appliedEndDate) && (
            <Button
              variant="outline"
              colorScheme="gray"
              size="sm"
              borderRadius="16px"
              onClick={handleClearFilter}
              leftIcon={<Icon as={MdClose} />}
            >
              Effacer
            </Button>
          )}
        </HStack>
      </Box>

    <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 6 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              icon={<Icon w="28px" h="28px" as={MdOutlineSell} color="blue" />}
            />
          }
          name="Nombre total de produits vendus"
          value={totalVentes}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={GrMoney} color={brandColor} />}
            />
          }
          name={`Valeur totale des ventes (${dashboardCurrency})`}
          value={isNaN(totalSalesValue) ? 0 : Math.round(totalSalesValue)}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />}
            />
          }
          name={`Valeur totale du stock (${dashboardCurrency})`}
          value={isNaN(totalInventoryValue) ? 0 : Math.round(totalInventoryValue)}
        />
      </SimpleGrid>

      {/* Pro-périmés Group */}
      <Box
        bg={isProPerimeExpanded ? cardBgExpanded : cardBg}
        borderRadius="20px"
        p={isProPerimeExpanded ? "10px" : "15px"}
        mb={isProPerimeExpanded ? "10px" : "20px"}
        cursor="pointer"
        onClick={() => setIsProPerimeExpanded(!isProPerimeExpanded)}
        boxShadow="sm"
        _hover={{ boxShadow: "md" }}
        transition="all 0.2s"
      >
        <Flex justify="space-between" align="center">
          <HStack spacing={3}>
            <IconBox
              w={isProPerimeExpanded ? "40px" : "56px"}
              h={isProPerimeExpanded ? "40px" : "56px"}
              bg={boxBg}
              icon={<Icon w={isProPerimeExpanded ? "24px" : "32px"} h={isProPerimeExpanded ? "24px" : "32px"} as={MdOutlineCalendarToday} color={brandColor} />}
            />
            <Box>
              <Text fontSize={isProPerimeExpanded ? "md" : "lg"} fontWeight="bold" color={textColor}>
                Statistiques produits pro-périmés
              </Text>
              {!isProPerimeExpanded && (
                <Text fontSize="sm" color="secondaryGray.600">
                  Cliquez pour afficher les détails
                </Text>
              )}
            </Box>
          </HStack>
          <Icon
            as={isProPerimeExpanded ? MdExpandLess : MdExpandMore}
            w="24px"
            h="24px"
            color={brandColor}
          />
        </Flex>
      </Box>

      <Collapse in={isProPerimeExpanded} animateOpacity>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, "2xl": 5 }}
          gap="20px"
          mb="20px"
        >
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon w="32px" h="32px" as={MdOutlineCalendarToday} color={brandColor} />
                }
              />
            }
            name="Produits pro-périmés vendus"
            value={venteProperime}
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={GrMoney} color={brandColor} />}
              />
            }
            name={`Equivalent pro-périmés vendus en ${CURRENCY.code}`}
            value={isNaN(totalPropVend) ? 0 : Math.round(totalPropVend)}
          />
          <MiniStatistics
            name="Produits pro-périmés en stock"
            value={products}
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
                }
              />
            }
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={
                  <Icon w="32px" h="32px" as={MdOutlineCalendarToday} color={brandColor} />
                }
              />
            }
            name="Nombre de spécialités propérimées"
            value={totalProp}
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={GrMoney} color={brandColor} />}
              />
            }
            name={`Equivalent pro-périmés en stock en ${CURRENCY.code}`}
            value={isNaN(equivalent) ? 0 : Math.round(equivalent)}
          />
        </SimpleGrid>
      </Collapse>

      {/* Vente Extra Group */}
      <Box
        bg={isVenteExtraExpanded ? cardBgExpanded : cardBg}
        borderRadius="20px"
        p={isVenteExtraExpanded ? "10px" : "15px"}
        mb={isVenteExtraExpanded ? "10px" : "20px"}
        cursor="pointer"
        onClick={() => setIsVenteExtraExpanded(!isVenteExtraExpanded)}
        boxShadow="sm"
        _hover={{ boxShadow: "md" }}
        transition="all 0.2s"
      >
        <Flex justify="space-between" align="center">
          <HStack spacing={3}>
            <IconBox
              w={isVenteExtraExpanded ? "40px" : "56px"}
              h={isVenteExtraExpanded ? "40px" : "56px"}
              bg={boxBg}
              icon={<Icon w={isVenteExtraExpanded ? "24px" : "32px"} h={isVenteExtraExpanded ? "24px" : "32px"} as={MdAddCircleOutline} color={brandColor} />}
            />
            <Box>
              <Text fontSize={isVenteExtraExpanded ? "md" : "lg"} fontWeight="bold" color={textColor}>
                Statistiques vente extra
              </Text>
              {!isVenteExtraExpanded && (
                <Text fontSize="sm" color="secondaryGray.600">
                  Cliquez pour afficher les détails
                </Text>
              )}
            </Box>
          </HStack>
          <Icon
            as={isVenteExtraExpanded ? MdExpandLess : MdExpandMore}
            w="24px"
            h="24px"
            color={brandColor}
          />
        </Flex>
      </Box>

      <Collapse in={isVenteExtraExpanded} animateOpacity>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 2, "2xl": 4 }}
          gap="20px"
          mb="20px"
        >
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="28px" h="28px" as={MdOutlineSell} color={brandColor} />}
              />
            }
            name="Produits vente extra vendus"
            value={venteExtraSold}
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={GrMoney} color={brandColor} />}
              />
            }
            name={`Equivalent vente extra vendus en ${CURRENCY.code}`}
            value={isNaN(venteExtraSoldValue) ? 0 : Math.round(venteExtraSoldValue)}
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />}
              />
            }
            name="Produits vente extra en stock"
            value={venteExtraStock}
          />
          <MiniStatistics
            startContent={
              <IconBox
                w="56px"
                h="56px"
                bg={boxBg}
                icon={<Icon w="32px" h="32px" as={GrMoney} color={brandColor} />}
              />
            }
            name={`Equivalent vente extra en stock en ${CURRENCY.code}`}
            value={isNaN(venteExtraStockValue) ? 0 : Math.round(venteExtraStockValue)}
          />
        </SimpleGrid>
      </Collapse>

      <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap="20px" mb="20px">
      <Utilisations startDate={appliedStartDate} endDate={appliedEndDate} />
      <PlaintesConsultees startDate={appliedStartDate} endDate={appliedEndDate} />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap="20px" mb="20px">
  {/* <CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} /> */}

  {/* This SimpleGrid will have a single column on mobile and will stack the children */}
  <SimpleGrid
  columns={{ base: 1, md: 2, xl: 2 }}
  gap={{ base: "20px", md: "40px", xl: "180px" }}
>
  <Box w={{ base: "60%", md: "100%" }}> {/* Set width for mobile view */}
    <Patients startDate={appliedStartDate} endDate={appliedEndDate} />
  </Box>
  <Box w={{ base: "28%", md: "100%" }}> {/* Set width for mobile view */}
    <Profils startDate={appliedStartDate} endDate={appliedEndDate} />
  </Box>
</SimpleGrid>

      </SimpleGrid>
      <SimpleGrid  columns={{ base: 1, md: 2, xl: 2 }}  gap={{ base: "20px",xl: "30px" }}>
      <ProperimeAndExtraSalesChart/>
      <InteractionsStat/>
      </SimpleGrid>

    </Box>
  );
}